module.exports = __webpack_public_path__ + "static/media/lincoln-vest.f3b45468.svg";